































import Vue from 'vue';

import { Component, Prop, Watch } from 'vue-property-decorator';

import { Resolve } from 'vue-di';

@Component<Footer>({})
export default class Footer extends Vue {
    public get footerLogoSrc() {
        return this.$settings.url(this.$settings.sandozFooterLogo);
    }
}
